// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Modal_wrap__3aOnp","buttonRow":"Modal_buttonRow__3rOay"};